import React from "react";
type PunchlineProps = {
  text: string;
  tone?: "light" | "dark";
  className?: string;
};
export function Punchline({
  text,
  tone = "light",
  className = ""
}: PunchlineProps) {
  return <p className={`text-sm font-extrabold uppercase tracking-[0.08em] ${tone === "light" ? "text-gold-ink" : "text-gold"} ${className}`} data-id="element-187" data-mp="3tejak5eh5167">
      {text}
    </p>;
}